import type { WorkflowGraph } from '../../graph';
import type { Store } from '../types';
import { withSyncGuard } from '../sync/syncFlag';

type SetState = (partial: Partial<Store> | ((state: Store) => Partial<Store>)) => void;
type GetState = () => Store;

export function createSelectionActions(
  set: SetState,
  get: GetState,
  getGraph: () => WorkflowGraph | null | undefined,
) {
  return {
    setSelection(cellIds: string[]): void {
      set((state) => ({ selection: { ...state.selection, cellIds } }));

      withSyncGuard(set, () => {
        const graph = getGraph();
        if (!graph) return;
        const cells = cellIds
          .map((id) => graph.getDataModel().getCell(id))
          .filter(Boolean);
        graph.setSelectionCells(cells as never[]);
      });
    },

    clearSelection(): void {
      set({ selection: { cellIds: [] } });
      withSyncGuard(set, () => {
        getGraph()?.clearSelection();
      });
    },

    toggleSelection(cellId: string): void {
      const current = get().selection.cellIds;
      const next = current.includes(cellId)
        ? current.filter((id) => id !== cellId)
        : [...current, cellId];

      set({ selection: { cellIds: next } });

      withSyncGuard(set, () => {
        const graph = getGraph();
        if (!graph) return;
        const cells = next
          .map((id) => graph.getDataModel().getCell(id))
          .filter(Boolean);
        graph.setSelectionCells(cells as never[]);
      });
    },
  };
}
